import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

const getPlans         = ()           => axios.get(`${API_URL}/api/superadmin/billing/plans`, auth()).then(r => r.data.plans);
const getCompanyBilling = (id)        => axios.get(`${API_URL}/api/superadmin/billing/companies/${id}`, auth()).then(r => r.data.billing);
const subscribeCompany  = (id, tier, customPriceUsd) =>
  axios.post(`${API_URL}/api/superadmin/billing/companies/${id}/subscribe`,
    { planTier: tier, ...(tier === 'custom' ? { customPriceUsd } : {}) }, auth()
  ).then(r => r.data);
const cancelSubscription = (id)       => axios.post(`${API_URL}/api/superadmin/billing/companies/${id}/cancel`, {}, auth()).then(r => r.data);
const reactivateSubscription = (id)   => axios.post(`${API_URL}/api/superadmin/billing/companies/${id}/reactivate`, {}, auth()).then(r => r.data);
const setExempt             = (id, v) => axios.patch(`${API_URL}/api/superadmin/billing/companies/${id}/exempt`, { billingExempt: v }, auth()).then(r => r.data);
const getPortalUrl      = (id)        => axios.get(`${API_URL}/api/superadmin/billing/companies/${id}/portal`, auth()).then(r => r.data.url);
const getSubscriptionStatus = ()      => axios.get(`${API_URL}/api/users/subscription-status`, auth()).then(r => r.data);
const getMyPortalUrl        = ()      => axios.get(`${API_URL}/api/users/billing-portal`, auth()).then(r => r.data.url);

const billingService = {
  getPlans, getCompanyBilling, subscribeCompany,
  cancelSubscription, reactivateSubscription,
  getPortalUrl, getSubscriptionStatus, setExempt, getMyPortalUrl,
};
export default billingService;
